// import { validateJWT } from '../utils/validateJWT';

import Cookies from 'js-cookie';

export const UserGuard = (): boolean => {
	const token = Cookies.get('accessToken'); // readFromStorage('accessToken');
	// const isValid = validateJWT(token);
	return !!token;
};
